import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "home-section",
  class: "bg-vh"
}
const _hoisted_2 = { class: "jumbotron jumbotron-fluid hero-img" }
const _hoisted_3 = { class: "container hero-text" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('hometitle')), 1),
        _createElementVNode("p", {
          class: "mx-auto",
          innerHTML: _ctx.$t('hometext')
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}